<template>
    <el-dialog :visible.sync="showTag" width="80%">
        <div class="main">
            <div>
                <h3 class="pt5 pb5 pl15 fs16">预约信息</h3>
                <div class="flex pl15 pr15 pt15 pb15">
                    <img :src="doc.docAvatar" alt="" class="flex0 radius50 mr10">
                    <div class="flex0">
                        <div class="name">
                            <span class="fs16">{{scheme.docname}}</span>
                            <span class="fs12 ml10">{{doc.docTitle}}</span>
                        </div>
                        <div class="hos mt5 fs14">{{doc.hosName}}</div>
                        <div class="dept mt5 fs14">{{scheme.deptname}}</div>
                    </div>
                    <div class="flex1 fs14">
                        <p class="flex aic jcc">{{scheme.schdate|schdateFilter}}</p>
                        <p class="flex aic jcc">{{scheme.ampm|ampmFilter}}</p>
                        <p class="flex aic jcc">{{scheme.weekNum}}</p>
                    </div>
                    <div class="flex0">
                        <p class="fs12 flex aic jcc">挂号费</p>
                        <p class="fs16 flex aic jcc" style="color: #F9BE00;">￥{{scheme.regfee}}元</p>
                        <p class="color_999 fs12 tar flex aic jcc">线下支付</p>
                    </div>
                </div>
            </div>
            <div class="mt15">
                <h3 class="pt5 pb5 pl15 fs16">请选择号源时段</h3>
                <ul class="flex">
                    <li class="flex0 flex aic jcc pt10 pb10" v-for="(data,index) in list">
                        <p class="pointer pt10 pb10 radius pl30 pr30" :class="{curr:index===currIndex}"
                           @click="currIndex=index">{{index+1}}号
                            {{data.numtime}}<span class="el-icon-check color_main"></span></p>
                    </li>
                </ul>
            </div>
        </div>
        <div slot="footer">
            <!--<el-button type="primary" @click="handler" size="mini">下一步</el-button>-->
            <div class="flex aic jcc">
                <div class="button flex aic jcc pointer" @click="handler">下一步</div>
            </div>
        </div>
    </el-dialog>
</template>
<style scoped lang="scss">
    @import "../../styles/var";
    @import "../../styles/mixins";
    .button{
        width:110px;
        height: 32px;
        background: #3692F9;
        border-radius: 2px;
        color: #ffffff;
    }

    .main {
        margin-top: -30px;
        margin-left: -5px;
        margin-right: -5px;

        > div {
            border: 1px solid $bgColor;

            h3 {
                border-bottom: 1px solid $bgColor;
                background-color: rgb(250, 250, 250);
            }
        }

        img {
            @include w_h(80px);
        }

        ul {
            flex-wrap: wrap;

            li {
                width: (100%/4);

                span {
                    display: none;
                }
            }
        }

        .curr {
            border: 1px solid $mainColor;
            background-color: $bgPrimaryColor;

            span {
                display: inline;
            }
        }
    }
</style>
<script>
  import {systemService} from "../../lib/service/system";
  import {ampmFilter, schdateFilter} from "../../lib/filters";
  import {bookService} from "../../lib/service/book";
  import {timeFormat} from "../../lib/utils";

  export default {
    name: "referral-num-dialog",
    data() {
      return {
        info: {},
        scheme: {},
        list: [],
        showTag: false,
        currIndex: -1
      }
    },
    computed: {
      doc() {
        return this.info.doc || {};
      }
    },
    filters: {schdateFilter, ampmFilter, timeFormat},
    created() {
    },
    methods: {
      async show(data) {
        this.currIndex = -1;
        this.scheme = data;
          console.log('选择号源');
          console.log(data);
        this.info = await systemService.docCard(data.docId);
        // this.list = await bookService.arrangeTime();
          this.list = await bookService.selectNum({
              'hosId':data.orgid,
              'schid':data.schid

          });
        this.showTag = true;
      },
      hide() {
        this.showTag = false;
      },
      handler() {
        let data = this.list[this.currIndex];
        if (!data) this.$message.error('请选择号源');
        else {
          this.hide();
          this.$emit('next', '加号', {
            num: data,
            scheme: this.scheme
          });
        }
      }
    },
  }
</script>

